import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/shopee.svg";
const ShopeeIcon = () => {
  return <YourSvg />;
};

export default ShopeeIcon;
